export default "__VITE_ASSET__d93985bb__"